export default __webpack_public_path__ + "static/media/tom.1490cf18.png";